function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAngleRight = function SvgIconAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.133 11.209",
    height: 12,
    width: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.628 11.21a.627.627 0 0 1-.45-1.067l4.447-4.556L.181 1.07a.627.627 0 1 1 .896-.88l4.875 4.956c.24.244.241.635.003.88L1.078 11.02a.626.626 0 0 1-.45.19Z",
    style: {
      fill: "#393d3c"
    },
    "data-name": "Layer 1"
  }));
};
export default SvgIconAngleRight;